// Constantes do dashboard "Indicadores de Gestão Docente" (cores das séries, rótulos das
// categorias e valores padrão das Parametrizações). Os dados fictícios do protótipo foram
// removidos: todos os indicadores usam dados reais.

export const SERIE = ['#1976D2', '#09D2FF', '#0D47A1', '#BDBDBD']
export const SEM_CURSO = 'DOCENTES SEM CURSO'
export const SEM_REGIME = 'Sem regime de trabalho'
export const SEM_TITULACAO = 'Sem titulação'
export const REGIMES_BASE = ['Horista', 'Tempo Parcial', 'Tempo Integral']
export const TITULACOES_BASE = ['Especialização', 'Mestrado', 'Doutorado']
export const REGIMES = [...REGIMES_BASE, SEM_REGIME]
export const TITULACOES = [...TITULACOES_BASE, SEM_TITULACAO]
export const PARAM_PADRAO = { metaTI: 20, metaStricto: 33.3, licenciados: false, hrMin: 1, hrExtra: 0, tpMin: 12, tpExtra: 25, tiMin: 40, tiExtra: 50, cursoRef: 'todos', regimeRef: 'auto' }
